import { addTranslations } from "lcm-iot-commons";

// warning! mutates state for translations of the `lib/translations` module
export async function mergeAppMessages(userLanguage: $TSFixMe) {
  const messages = (
    await import(
      /* webpackChunkName: "translations" */
      `./${userLanguage}`
    )
  ).default;
  addTranslations(userLanguage, messages);
  return messages;
}
